const API_URL = '';

/**
 * Resolve image URL: relative paths (/api/media/...) get API_URL prepended,
 * absolute URLs (https://...) stay as-is.
 * This ensures images work on both preview and production domains.
 */
export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${API_URL}${url}`;
};
